/* HJ header (CRO refresh v3). Markup: sections/hj-header.liquid. Styles: assets/hj-header.css.
   Mobile drawer (open/close, swipe, focus trap, one-open accordions, category grid),
   desktop menus (hover intent, click toggle, scrim), app-perk rotation and the
   show-on-scroll-up header. Cart and search reuse the theme's own drawers through
   aria-controls, and the currency picker is a plain Shopify localization form. */
(function () {
  'use strict';
  if (window.__hjnHeader) return; /* the theme editor can re-run this file when it reloads the section */
  window.__hjnHeader = true;

  var EASE = 'cubic-bezier(.22,1,.36,1)';
  var PERK_MS = 2600;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var desktop = window.matchMedia('(min-width: 990px)');
  var teardown = null;

  function init() {
    var root = document.querySelector('[data-hjn]');
    if (!root) return;
    if (teardown) teardown();

    var ac = new AbortController();
    var on = function (el, type, fn, opts) {
      if (el) el.addEventListener(type, fn, Object.assign({ signal: ac.signal }, opts || {}));
    };
    var sec = root.closest('.shopify-section') || document;
    var html = document.documentElement;
    var bar = root.querySelector('[data-hjn-bar]');
    var burger = root.querySelector('[data-hjn-burger]');
    var dw = sec.querySelector('[data-hjn-dw]');
    var drawer = dw && dw.querySelector('[data-hjn-drawer]');
    var closeBtn = dw && dw.querySelector('.hjn-close');
    var drawerOpen = false;
    var dOpen = '';
    var timers = {};
    var observers = [];

    /* ---------- App link: App Store on iOS, Play Store on Android, app page elsewhere ---------- */
    var ua = navigator.userAgent || '';
    var isAndroid = /Android/i.test(ua);
    var isIOS = !isAndroid && (/iPhone|iPad|iPod/i.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1));
    var appHref = isAndroid ? root.dataset.android : isIOS ? root.dataset.ios : '';
    if (appHref) sec.querySelectorAll('[data-hjn-app-link]').forEach(function (a) { a.href = appHref; });

    /* ---------- Perk rotation (shared by the drawer and desktop Shop panel) ---------- */
    var apps = Array.prototype.slice.call(sec.querySelectorAll('[data-hjn-app]'));
    var perkCount = apps.length ? apps[0].querySelectorAll('[data-hjn-perk-layer]').length : 0;
    var tick = 0;

    function paintPerks() {
      apps.forEach(function (app) {
        app.querySelectorAll('[data-hjn-perk-layer]').forEach(function (el, i) {
          el.classList.toggle('is-on', i === tick);
        });
        app.querySelectorAll('[data-hjn-perk-text]').forEach(function (el, i) {
          el.classList.toggle('is-on', i === tick);
          el.classList.toggle('is-prev', (i - tick + perkCount) % perkCount === perkCount - 1);
        });
        app.querySelectorAll('[data-hjn-perk-seg]').forEach(function (el, i) {
          el.classList.toggle('is-done', i < tick);
          el.classList.remove('is-on');
          if (i === tick) {
            void el.offsetWidth; /* restart the fill animation */
            el.classList.add('is-on');
          }
        });
      });
    }
    function perksVisible() {
      return drawerOpen || dOpen === 'shop';
    }
    function syncPerks() {
      clearInterval(timers.perk);
      timers.perk = 0;
      if (perkCount > 1 && !reduced.matches && !document.hidden && perksVisible()) {
        timers.perk = setInterval(function () {
          tick = (tick + 1) % perkCount;
          paintPerks();
        }, PERK_MS);
      }
    }
    sec.querySelectorAll('[data-hjn-perk-seg]').forEach(function (btn) {
      on(btn, 'click', function () {
        tick = +btn.getAttribute('data-hjn-perk-seg') || 0;
        paintPerks();
        syncPerks();
      });
    });
    on(document, 'visibilitychange', function () {
      if (!document.hidden && perksVisible()) paintPerks();
      syncPerks();
    });

    /* ---------- Sticky header: hide on scroll down, show on scroll up ---------- */
    var hidden = false;
    var lastY = window.scrollY;
    var threshold = 0;
    function measure() {
      var ann = root.querySelector('.hjn-ann');
      threshold = (ann ? ann.offsetHeight : 0) + (bar ? bar.offsetHeight : 0);
    }
    function showBar() {
      if (hidden) { hidden = false; bar.classList.remove('is-hidden'); }
    }
    if (bar && root.dataset.sticky === 'scroll_up') {
      measure();
      var scrollQueued = false;
      on(window, 'scroll', function () {
        if (scrollQueued) return;
        scrollQueued = true;
        requestAnimationFrame(function () {
          scrollQueued = false;
          var y = window.scrollY;
          if (drawerOpen || dOpen || y <= threshold) showBar();
          else if (y > lastY + 2 && !hidden) { hidden = true; bar.classList.add('is-hidden'); }
          else if (y < lastY - 2) showBar();
          lastY = y;
        });
      }, { passive: true });
      on(window, 'resize', measure, { passive: true });
    }

    /* ---------- Mobile drawer ---------- */
    function focusables() {
      return Array.prototype.filter.call(
        drawer.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])'),
        function (el) {
          return el.checkVisibility ? el.checkVisibility({ visibilityProperty: true }) : el.getClientRects().length > 0;
        }
      );
    }
    function openDrawer() {
      if (!dw || drawerOpen) return;
      drawerOpen = true;
      clearTimeout(timers.swipe);
      drawer.style.transition = 'none';
      drawer.style.transform = '';
      dw.classList.add('is-open');
      if (burger) burger.setAttribute('aria-expanded', 'true');
      html.classList.add('hjn-lock');
      showBar();
      paintPerks();
      syncPerks();
      updateThumb();
      clearTimeout(timers.focus);
      timers.focus = setTimeout(function () { if (closeBtn) closeBtn.focus({ preventScroll: true }); }, 80);
    }
    function closeDrawer() {
      if (!dw || !drawerOpen) return;
      var hadFocus = drawer.contains(document.activeElement);
      drawerOpen = false;
      dw.classList.remove('is-open');
      if (burger) burger.setAttribute('aria-expanded', 'false');
      html.classList.remove('hjn-lock');
      clearTimeout(timers.focus);
      syncPerks();
      if (hadFocus && burger) burger.focus({ preventScroll: true });
    }

    if (dw) {
      on(burger, 'click', openDrawer);
      dw.querySelectorAll('[data-hjn-close]').forEach(function (el) { on(el, 'click', closeDrawer); });
      /* Other theme buttons that used to open the old mobile menu */
      on(document, 'click', function (e) {
        var t = e.target.closest && e.target.closest('[aria-controls="menu_mobile"]');
        if (t && !desktop.matches) { e.preventDefault(); openDrawer(); }
      });

      on(drawer, 'keydown', function (e) {
        if (e.key !== 'Tab' || !drawerOpen) return;
        var f = focusables();
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1], cur = document.activeElement;
        if (e.shiftKey && (cur === first || !drawer.contains(cur))) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && (cur === last || !drawer.contains(cur))) { e.preventDefault(); first.focus(); }
      });

      /* One accordion open at a time */
      var accs = Array.prototype.slice.call(dw.querySelectorAll('[data-hjn-acc]'));
      accs.forEach(function (btn) {
        on(btn, 'click', function () {
          var opening = btn.getAttribute('aria-expanded') !== 'true';
          accs.forEach(function (b) { b.setAttribute('aria-expanded', b === btn && opening ? 'true' : 'false'); });
          if (opening && btn.getAttribute('aria-controls') === 'hjn-acc-shop') updateThumb();
        });
      });

      /* Swipe left to close. Drags that start on the category grid are ignored. */
      var sw = null, swMoved = false;
      on(drawer, 'pointerdown', function (e) {
        sw = e.target.closest('[data-hscroll]') ? null : { x: e.clientX, y: e.clientY, on: false, dx: 0 };
      });
      on(drawer, 'pointermove', function (e) {
        if (!sw) return;
        var dx = e.clientX - sw.x, dy = e.clientY - sw.y;
        if (!sw.on) {
          if (dx < -8 && Math.abs(dx) > Math.abs(dy) * 1.2) {
            sw.on = true;
            try { drawer.setPointerCapture(e.pointerId); } catch (_) {}
          } else return;
        }
        sw.dx = Math.min(0, dx);
        drawer.style.transition = 'none';
        drawer.style.transform = 'translateX(' + sw.dx + 'px)';
      });
      var swEnd = function () {
        if (!sw) return;
        var s = sw;
        sw = null;
        if (!s.on) return;
        swMoved = true;
        setTimeout(function () { swMoved = false; }, 0);
        if (s.dx < -70) {
          closeDrawer();
          clearTimeout(timers.swipe);
          timers.swipe = setTimeout(function () { drawer.style.transition = 'none'; drawer.style.transform = ''; }, 700);
        } else {
          drawer.style.transition = 'transform .35s ' + EASE;
          drawer.style.transform = 'translateX(0)';
        }
      };
      on(drawer, 'pointerup', swEnd);
      on(drawer, 'pointercancel', swEnd);
      on(drawer, 'click', function (e) {
        if (swMoved) { e.preventDefault(); e.stopPropagation(); }
      }, { capture: true });
    }

    /* Category grid: progress thumb + mouse drag */
    var cats = dw && dw.querySelector('[data-hscroll]');
    var thumb = dw && dw.querySelector('[data-hjn-thumb]');
    var thumbQueued = false;
    function updateThumb() {
      if (!cats || !thumb || thumbQueued) return;
      thumbQueued = true;
      requestAnimationFrame(function () {
        thumbQueued = false;
        var sw = cats.scrollWidth || 1, cw = cats.clientWidth || 1;
        thumb.style.width = Math.min(100, cw / sw * 100) + '%';
        thumb.style.transform = 'translateX(' + (cats.scrollLeft / cw * 100) + '%)';
      });
    }
    if (cats) {
      on(cats, 'scroll', updateThumb, { passive: true });
      on(window, 'resize', updateThumb, { passive: true });
      var drag = null, dragMoved = false;
      on(cats, 'pointerdown', function (e) {
        if (e.pointerType !== 'mouse') return;
        drag = { x: e.clientX, sl: cats.scrollLeft, moved: false };
        clearTimeout(timers.snap);
        cats.classList.add('is-dragging');
        try { cats.setPointerCapture(e.pointerId); } catch (_) {}
      });
      on(cats, 'pointermove', function (e) {
        if (!drag) return;
        var dx = e.clientX - drag.x;
        if (Math.abs(dx) > 4) drag.moved = true;
        cats.scrollLeft = drag.sl - dx;
      });
      var dragEnd = function () {
        if (!drag) return;
        dragMoved = drag.moved;
        drag = null;
        cats.scrollTo({ left: Math.min(cats.scrollWidth - cats.clientWidth, Math.round(cats.scrollLeft / 100) * 100), behavior: 'smooth' });
        timers.snap = setTimeout(function () { cats.classList.remove('is-dragging'); }, 420);
        setTimeout(function () { dragMoved = false; }, 0);
      };
      on(cats, 'pointerup', dragEnd);
      on(cats, 'pointercancel', dragEnd);
      on(cats, 'click', function (e) {
        if (dragMoved) { e.preventDefault(); e.stopPropagation(); }
      }, { capture: true });
      on(cats, 'dragstart', function (e) { e.preventDefault(); });
    }

    /* ---------- Desktop menus ---------- */
    var dds = Array.prototype.slice.call(root.querySelectorAll('[data-hjn-dd]'));
    var openedAt = 0;
    function clearDd() { clearTimeout(timers.ddOpen); clearTimeout(timers.ddClose); }
    function setDd(id) {
      dOpen = id;
      openedAt = Date.now();
      dds.forEach(function (w) {
        var isOn = w.getAttribute('data-hjn-dd') === id;
        w.classList.toggle('is-open', isOn);
        var b = w.querySelector('[data-hjn-dd-btn]');
        if (b) b.setAttribute('aria-expanded', isOn ? 'true' : 'false');
      });
      if (bar) {
        bar.classList.toggle('has-open', !!id);
        bar.classList.toggle('has-scrim', !!id && id !== 'cur');
      }
      if (id) showBar();
      if (id === 'shop') paintPerks();
      syncPerks();
    }
    dds.forEach(function (w) {
      var id = w.getAttribute('data-hjn-dd');
      var btn = w.querySelector('[data-hjn-dd-btn]');
      on(w, 'mouseenter', function () {
        if (!desktop.matches) return;
        clearDd();
        if (dOpen) { if (dOpen !== id) setDd(id); }
        else timers.ddOpen = setTimeout(function () { setDd(id); }, 90);
      });
      on(w, 'mouseleave', function () {
        if (!desktop.matches) return;
        clearDd();
        timers.ddClose = setTimeout(function () { setDd(''); }, 180);
      });
      on(btn, 'click', function () {
        clearDd();
        if (dOpen === id && Date.now() - openedAt > 450) setDd('');
        else setDd(id);
      });
      on(w, 'focusout', function (e) {
        if (dOpen === id && e.relatedTarget && !w.contains(e.relatedTarget)) setDd('');
      });
    });
    on(root.querySelector('[data-hjn-scrim-d]'), 'click', function () { clearDd(); setDd(''); });

    /* ---------- Shared ---------- */
    on(document, 'keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (drawerOpen) closeDrawer();
      if (dOpen) {
        var w = root.querySelector('[data-hjn-dd="' + dOpen + '"]');
        var hadFocus = w && w.contains(document.activeElement);
        clearDd();
        setDd('');
        if (hadFocus) w.querySelector('[data-hjn-dd-btn]').focus({ preventScroll: true });
      }
    });
    on(desktop, 'change', function () {
      if (desktop.matches) closeDrawer();
      else { clearDd(); setDd(''); }
      if (bar && root.dataset.sticky === 'scroll_up') measure();
    });
    on(reduced, 'change', syncPerks);

    /* Hide the cart badge at 0. The theme's <hdt-cart-count> updates the number. */
    sec.querySelectorAll('.hjn-badge').forEach(function (b) {
      var mo = new MutationObserver(function () { b.setAttribute('data-hjn-count', b.textContent.trim()); });
      mo.observe(b, { childList: true, characterData: true, subtree: true });
      observers.push(mo);
    });

    teardown = function () {
      ac.abort();
      Object.keys(timers).forEach(function (k) { clearTimeout(timers[k]); clearInterval(timers[k]); });
      observers.forEach(function (mo) { mo.disconnect(); });
      html.classList.remove('hjn-lock');
      teardown = null;
    };
  }

  init();
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector && e.target.querySelector('[data-hjn]')) init();
  });
  document.addEventListener('shopify:section:unload', function (e) {
    if (teardown && e.target.querySelector && e.target.querySelector('[data-hjn]')) teardown();
  });
})();
